var map = {
	"./blockchain/GridtNftDataMapper.js": 16323,
	"./blockchain/datasource/ContractAddressDataSource.js": 67986,
	"./blockchain/usecase/get_image_for_layer_usecase.js": 1883,
	"./blockchain/usecase/get_transaction_data_for_layers_usecase.js": 90226,
	"./edit/paste.js": 22982,
	"./edit/selection.js": 19835,
	"./edit/undo.js": 7143,
	"./effects/abstract/css.js": 70731,
	"./effects/black_and_white.js": 43722,
	"./effects/blueprint.js": 12354,
	"./effects/blur.js": 83380,
	"./effects/box_blur.js": 73678,
	"./effects/brightness.js": 46334,
	"./effects/contrast.js": 66667,
	"./effects/denoise.js": 76374,
	"./effects/dither.js": 60797,
	"./effects/dot_screen.js": 43301,
	"./effects/edge.js": 21580,
	"./effects/emboss.js": 78302,
	"./effects/enrich.js": 25060,
	"./effects/grains.js": 32857,
	"./effects/grayscale.js": 69490,
	"./effects/heatmap.js": 62689,
	"./effects/hue_rotate.js": 91221,
	"./effects/mosaic.js": 43621,
	"./effects/negative.js": 91714,
	"./effects/night_vision.js": 33402,
	"./effects/oil.js": 64033,
	"./effects/pencil.js": 16,
	"./effects/saturate.js": 75644,
	"./effects/sepia.js": 79991,
	"./effects/shadow.js": 89177,
	"./effects/sharpen.js": 40486,
	"./effects/solarize.js": 53396,
	"./effects/tilt_shift.js": 10105,
	"./effects/vibrance.js": 86595,
	"./effects/vignette.js": 70843,
	"./effects/vintage.js": 65787,
	"./effects/zoom_blur.js": 54132,
	"./file/new.js": 79317,
	"./file/open.js": 18824,
	"./file/print.js": 99184,
	"./file/quickload.js": 8264,
	"./file/quicksave.js": 76545,
	"./file/save.js": 16874,
	"./file/search.js": 25679,
	"./help/about.js": 7931,
	"./help/shortcuts.js": 80813,
	"./help/translate.js": 8756,
	"./image/auto_adjust.js": 82181,
	"./image/color_corrections.js": 78367,
	"./image/convert_to_256_colors.js": 61578,
	"./image/decrease_colors.js": 53451,
	"./image/flip.js": 46715,
	"./image/grid.js": 13616,
	"./image/histogram.js": 82708,
	"./image/information.js": 4256,
	"./image/opacity.js": 92547,
	"./image/palette.js": 15110,
	"./image/resize.js": 4428,
	"./image/rotate.js": 44315,
	"./image/size.js": 49345,
	"./image/translate.js": 93812,
	"./image/trim.js": 24508,
	"./image/zoom.js": 72335,
	"./layer/clear.js": 81971,
	"./layer/composition.js": 65256,
	"./layer/delete.js": 24871,
	"./layer/differences.js": 50198,
	"./layer/duplicate.js": 80851,
	"./layer/flatten.js": 68200,
	"./layer/merge.js": 62314,
	"./layer/move.js": 86069,
	"./layer/new.js": 94064,
	"./layer/raster.js": 40997,
	"./layer/rename.js": 27274,
	"./layer/visibility.js": 30852,
	"./tools/borders.js": 15247,
	"./tools/color_to_alpha.js": 90112,
	"./tools/color_zoom.js": 6481,
	"./tools/content_fill.js": 23045,
	"./tools/grid.js": 88870,
	"./tools/keypoints.js": 38356,
	"./tools/replace_color.js": 3532,
	"./tools/restore_alpha.js": 83057,
	"./tools/settings.js": 92659,
	"./tools/sprites.js": 75610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92714;